export const NAV_TOGGLE = 'NAV_TOGGLE';
